import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = ({ theme }) => ({
    '& .ant-modal': {
        textAlign: 'right',
    },

    '& .ant-modal .ant-modal-container': {
        borderRadius: '1rem',
    },
});

export const icon: TRuleWithTheme = ({ theme }) => ({
    float: 'left',

    marginRight: '1rem',
    marginBottom: '1rem',

    fontSize: '1.5rem',
    color: theme.colors.orange,
});

export const title: TRuleWithTheme = ({ theme }) => ({
    marginBottom: '1rem',
});

export const text: TRuleWithTheme = ({ theme }) => ({
    marginBottom: '2.5rem',

    textAlign: 'left',

    color: theme.colors.foregroundsTertiary,
});
